import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-brand-navy mt-[60px]" data-id="element-216">
      <div className="max-w-[1100px] mx-auto py-9 px-6 grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr] gap-6 md:gap-10" data-id="element-217">
        <div data-id="element-218">
          <div className="flex flex-col" data-id="element-219">
            <div className="font-serif text-[1.5rem] font-bold text-white tracking-[-0.02em] leading-none" data-id="element-220">
              Vital<span className="text-brand-red" data-id="element-221">-</span>Wegweiser
            </div>
            <div className="font-sans text-[0.65rem] tracking-[0.14em] uppercase text-white/40 mt-1" data-id="element-222">
              Ihr Ratgeber für Gesundheit & Wohlbefinden
            </div>
          </div>
          <p className="font-sans text-[0.75rem] text-white/50 leading-[1.7] mt-3" data-id="element-223">
            Vital-Wegweiser informiert seit Jahren über Gesundheitsthemen,
            Naturheilkunde und ein aktives Leben. Unsere Inhalte sind
            redaktionell unabhängig und wissenschaftlich recherchiert.
          </p>
        </div>

        <div data-id="element-224">
          <h5 className="font-sans text-[0.65rem] tracking-[0.12em] uppercase text-white/40 mb-3" data-id="element-225">
            Themen
          </h5>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-226">
            Männergesundheit
          </a>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-227">
            Schlaf & Erholung
          </a>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-228">
            Naturheilkunde
          </a>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-229">
            Ernährung
          </a>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-230">
            Fitness
          </a>
        </div>

        <div data-id="element-231">
          <h5 className="font-sans text-[0.65rem] tracking-[0.12em] uppercase text-white/40 mb-3" data-id="element-232">
            Magazin
          </h5>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-233">
            Über uns
          </a>
          <Link to="/impressum" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-234">
            Impressum
          </Link>
          <Link to="/datenschutz" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-235">
            Datenschutz
          </Link>
          <Link to="/kontakt" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-236">
            Kontakt
          </Link>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-237">
            Werben
          </a>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-238">
        <div className="max-w-[1100px] mx-auto py-4 px-6 flex flex-col md:flex-row justify-between items-center gap-2" data-id="element-239">
          <p className="font-sans text-[0.68rem] text-white/35 m-0" data-id="element-240">
            © 2026 Vital-Wegweiser. Alle Rechte vorbehalten.
          </p>
          <p className="font-sans text-[0.68rem] text-white/35 m-0" data-id="element-241">
            <strong className="text-white/60 font-medium" data-id="element-242">
              Anzeige / Advertorial
            </strong>{' '}
            &nbsp;·&nbsp;{' '}
            <Link to="/impressum" className="text-white/35 hover:text-white transition-colors" data-id="element-243">
              Impressum
            </Link>{' '}
            &nbsp;·&nbsp;{' '}
            <Link to="/datenschutz" className="text-white/35 hover:text-white transition-colors" data-id="element-244">
              Datenschutz
            </Link>
          </p>
        </div>
      </div>
    </footer>;
}